import { useEffect, useState } from "react";
import AdminLayout from "../AdminLayout";
import { getUsers as fetchUsers } from "../../../api/auth";

function Users() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getUsers = async () => {
            try {
                const data = await fetchUsers();

                setUsers(Array.isArray(data) ? data : []);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        getUsers();
    }, []);

    return (
        <AdminLayout>
            <div className="mb-6">
                <p className="eyebrow">Community</p>
                <h2 className="mt-2 font-display text-4xl text-ink">Users</h2>
            </div>

            <div className="overflow-hidden rounded-2xl border border-sand bg-white shadow-card">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-cream">
                            <tr>
                                <th className="w-20 px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    #
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Name
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Email
                                </th>
                                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-widest text-muted">
                                    Role
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading || users.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="border-t border-sand/60 px-4 py-8 text-center text-muted"
                                    >
                                        {loading ? "Loading Users..." : "No Users Found"}
                                    </td>
                                </tr>
                            ) : (
                                users.map((user, index) => (
                                    <tr key={user.id} className="hover:bg-cream/40">
                                        <td className="border-t border-sand/60 px-4 py-3 text-muted">
                                            {index + 1}
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3 font-medium text-ink">
                                            {user.name}
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3 text-muted">
                                            {user.email}
                                        </td>

                                        <td className="border-t border-sand/60 px-4 py-3">
                                            <span className="chip">{user.role}</span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </AdminLayout>
    );
}

export default Users;
